import ReactMarkdown from "react-markdown"

import { useTrackIntegrationViewedEvent } from "src/data/integrations/hooks/useSendIntegrationEvents"
import { TIntegration } from "src/data/integrations/types/integrationTypes"
import { DefaultBox } from "src/ui/Layout/DefaultBox"
import { MLink } from "src/ui/Link/MLink"

export function AboutIntegrationTab({
  integration,
  tabId,
  description,
  richDescription,
}: {
  integration: TIntegration
  tabId: string
  description: string
  richDescription: string
}) {
  useTrackIntegrationViewedEvent({
    integration,
    tabId,
  })
  return (
    <DefaultBox size="small">
      {richDescription ? (
        <ReactMarkdown
          components={{
            a: ({ href, children }) => (
              <MLink color="unset" href={href ?? ""}>
                {children as React.ReactNode}
              </MLink>
            ),
          }}
        >
          {richDescription}
        </ReactMarkdown>
      ) : (
        <div>{description}</div>
      )}
    </DefaultBox>
  )
}
